export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            投稿咨询
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            欢迎优质国产视频创作者与内容方联系我们进行投稿合作，91免费视频网站为您提供海量曝光机会，让您的作品被更多观众看到。
          </p>
          <div className="mt-8 p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">投稿邮箱</h3>
                <p className="mt-1 text-xs text-foreground-500">tougao@91freevideo.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-accent-500 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">商务合作</h3>
                <p className="mt-1 text-xs text-foreground-500">hezuo@91freevideo.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-secondary-500 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">反馈建议</h3>
                <p className="mt-1 text-xs text-foreground-500">fankui@91freevideo.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}